import { FORBIDDEN_CHARACTERS } from "~~/constants/validation";

export const extractForbiddenCharacters = (value?: string | null): string[] => {

  if (!value) {

    return [];

  }

  return FORBIDDEN_CHARACTERS.filter(char => value.includes(char));

};

/**
 * @param {unknown} param
 */
export const assertNoForbiddenCharacters = (param: unknown) => {

  if (!param) {

    return;
  
  }

  if (typeof param === 'string') {

    const invalidChars = extractForbiddenCharacters(param);

    if (invalidChars.length > 0) {

      throw new Error(`Parameters contain forbidden characters: ${invalidChars.join(', ')}`);
    
    }

    return;
  
  }

  if (Array.isArray(param)) {

    param.forEach(item => assertNoForbiddenCharacters(item));

    return;
  
  }

  if (param && typeof param === 'object') {

    if ('name' in param && param.name === 'vatValidationRawResponse') {

      return; // Skip validation for raw VAT validation responses since it contains HTML
    
    }

    Object.values(param as Record<string, unknown>).forEach(value => assertNoForbiddenCharacters(value));
  
  }

};
